import { useEffect, useRef } from 'react';
const COLUMN_DRAG_THRESHOLD_PX = 5;
export function useTableHeaderCell({ column, isGroupColumn, onClick, onDragStart, onDragMove, onDragEnd, onResizeStart, onResizeMove, onResizeEnd }) {
    const dragRef = useRef(null);
    const suppressNextClickRef = useRef(false);
    const dragEventListenersRef = useRef(null);
    const resizeEventListenersRef = useRef(null);
    useEffect(() => {
        return () => {
            var _a, _b;
            (_a = dragEventListenersRef.current) === null || _a === void 0 ? void 0 : _a.call(dragEventListenersRef);
            (_b = resizeEventListenersRef.current) === null || _b === void 0 ? void 0 : _b.call(resizeEventListenersRef);
        };
    }, []);
    const handleMouseDown = (event) => {
        var _a;
        if (isGroupColumn) {
            return;
        }
        if (event.button !== 0) {
            return;
        }
        (_a = dragEventListenersRef.current) === null || _a === void 0 ? void 0 : _a.call(dragEventListenersRef);
        dragRef.current = {
            startX: event.clientX,
            dragging: false
        };
        const processMouseMove = (e) => {
            const state = dragRef.current;
            if (state === null) {
                return;
            }
            const dx = e.clientX - state.startX;
            if (!state.dragging) {
                if (Math.abs(dx) < COLUMN_DRAG_THRESHOLD_PX) {
                    return;
                }
                state.dragging = true;
                onDragStart(column, dx);
                return;
            }
            onDragMove(column, dx);
        };
        const onWindowMouseUp = (e) => {
            window.removeEventListener('mousemove', processMouseMove, true);
            window.removeEventListener('mouseup', onWindowMouseUp, true);
            dragEventListenersRef.current = null;
            const state = dragRef.current;
            const dx = e.clientX - state.startX;
            dragRef.current = null;
            if ((state === null || state === void 0 ? void 0 : state.dragging) === true) {
                onDragEnd(column, dx);
                suppressNextClickRef.current = true;
            }
        };
        dragEventListenersRef.current = () => {
            window.removeEventListener('mousemove', processMouseMove, true);
            window.removeEventListener('mouseup', onWindowMouseUp, true);
        };
        window.addEventListener('mousemove', processMouseMove, true);
        window.addEventListener('mouseup', onWindowMouseUp, true);
    };
    const handleClick = () => {
        if (suppressNextClickRef.current) {
            suppressNextClickRef.current = false;
            return;
        }
        onClick(column);
    };
    const handleResizeMouseDown = (event) => {
        var _a;
        if (event.button !== 0) {
            return;
        }
        event.stopPropagation();
        event.preventDefault();
        (_a = resizeEventListenersRef.current) === null || _a === void 0 ? void 0 : _a.call(resizeEventListenersRef);
        const startX = event.clientX;
        onResizeStart(column, 0);
        const processMouseMove = (e) => {
            const offsetX = e.clientX - startX;
            onResizeMove(column, offsetX);
        };
        const onWindowMouseUp = (e) => {
            window.removeEventListener('mousemove', processMouseMove, true);
            window.removeEventListener('mouseup', onWindowMouseUp, true);
            resizeEventListenersRef.current = null;
            const offsetX = e.clientX - startX;
            onResizeEnd(column, offsetX);
            suppressNextClickRef.current = true;
        };
        resizeEventListenersRef.current = () => {
            window.removeEventListener('mousemove', processMouseMove, true);
            window.removeEventListener('mouseup', onWindowMouseUp, true);
        };
        window.addEventListener('mousemove', processMouseMove, true);
        window.addEventListener('mouseup', onWindowMouseUp, true);
    };
    return {
        handleMouseDown,
        handleClick,
        handleResizeMouseDown
    };
}
